import { erpAxios } from '..';

const statusKompletiran = async (data) => {
  const res = await erpAxios.post(`/statusZahtjeva/kompletiran`, data);
  return res;
};

export default statusKompletiran;
